'use client';

import { useFormikContext } from 'formik';

import { ExperianModalCore } from './ExperianModalCore';
import type { ExperianModalType, FormProps } from './types';

export function ExperianModal({
    experianResponse,
    saveSelectedAddress,
    loading,
    setIsLoading,
    onEditAddressClick,
    onVisibilityChange,
    onSaveError,
}: Readonly<ExperianModalType>) {
    const { values: currentFormValues, setValues } = useFormikContext<FormProps>();
    return (
        <ExperianModalCore
            experianResponse={experianResponse}
            saveSelectedAddress={saveSelectedAddress}
            loading={loading}
            setIsLoading={setIsLoading}
            onEditAddressClick={onEditAddressClick}
            onVisibilityChange={onVisibilityChange}
            onSaveError={onSaveError}
            currentFormValues={currentFormValues}
            setCurrentFormValues={setValues}
        />
    );
}
